import { IGameLine } from './interfaces';
import Sizes from './sizes';
import { LineOrientations } from './types';

/**
 * Возвращает позиции фишек для
 * @param {IGameLine} line линия для которой рассчитываются позиции фишек
 * @return [{x},{y}] массив значений x, y, индекс элемента равен номеру фишки
 */
export default function getPositionsForCheckers(line: IGameLine, gameSizes: Sizes, addOneMore?: boolean) {
  const result = [];
  const checkerSize = gameSizes.getCheckerSize().width;
  const lineHeight = gameSizes.getLineSize().height;
  let checkersCount = line.checkers.length;

  if (addOneMore) {
    checkersCount += 1;
  }

  const sign = line.orientation === LineOrientations.ORIENTATION_NORMAL ? -1 : 1;
  // let startY = line.Y + sign * line.width / 2;

  let stretchFactor = 0.8;
  const allCheckersHeight = checkersCount * checkerSize;

  if (allCheckersHeight * stretchFactor > lineHeight) {
    // значит мы должны сжимать пешки на линии
    stretchFactor = lineHeight / allCheckersHeight;
  }

  for (let i = 0; i < checkersCount; i++) {
    let newY = line.position.y - sign * i * checkerSize * stretchFactor;
    const newX = line.position.x;

    if (line.orientation === LineOrientations.ORIENTATION_REVERSED) {
      newY += line.size.height / 2 - checkerSize / 2;
    } else {
      newY -= line.size.height / 2 - checkerSize / 2;
    }
    result.push({ x: newX, y: newY });
  }
  return result;
}
